import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { dynamicFormsApi } from './dynamic-forms.api';
import type { DynamicFormsListParams } from '../types';

export const dynamicFormKeys = {
  all: ['dynamic-forms'] as const,
  lists: () => [...dynamicFormKeys.all, 'list'] as const,
  list: (filters: DynamicFormsListParams) =>
    [...dynamicFormKeys.lists(), filters] as const,
  details: () => [...dynamicFormKeys.all, 'detail'] as const,
  detail: (id: number) => [...dynamicFormKeys.details(), id] as const,
  activeByType: (type: string) =>
    [...dynamicFormKeys.all, 'active', type] as const
};

export const dynamicFormQueries = {
  list: (filters: DynamicFormsListParams = {}) =>
    queryOptions({
      queryKey: dynamicFormKeys.list(filters),
      queryFn: () => dynamicFormsApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number, options?: { scope?: 'all' }) =>
    queryOptions({
      queryKey: options?.scope
        ? ([...dynamicFormKeys.detail(id), options.scope] as const)
        : dynamicFormKeys.detail(id),
      queryFn: () => dynamicFormsApi.getById(id, options),
      enabled: id > 0
    }),

  activeByType: (type: string, options?: { scope?: 'all' }) =>
    queryOptions({
      queryKey: options?.scope
        ? ([...dynamicFormKeys.activeByType(type), options.scope] as const)
        : dynamicFormKeys.activeByType(type),
      queryFn: () => dynamicFormsApi.getActiveByType(type, options),
      enabled: !!type
    })
};
